import React from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { Icon } from 'components/ui';

import styles from './RequestResult.module.scss';

type BaseProps = {
  className?: string;
  title: string;
};

type BlockProps = BaseProps & {
  editLink?: string;
  onEditClick?: () => void;
  isEditable?: boolean
};

export const Block: React.FC<BlockProps> = ({ className, editLink, title, children, isEditable, onEditClick }) => (
  <div className={clsx(styles.block, className)}>
    <div className={styles.head}>
      <h5>{title}</h5>
      {editLink ? (
        <Link to={editLink} className={styles.edit}>
          <Icon name="edit" />
          Edit
        </Link>
      ) : isEditable && onEditClick ? (
        <a className={styles.edit} onClick={onEditClick}>
          <Icon name="edit" />
          Edit
        </a>
      ) : null}
    </div>
    <div className={clsx(styles.body, 'row')}>{children}</div>
  </div>
);

type ItemProps = BaseProps;

export const Item: React.FC<ItemProps> = ({ className, title, children }) => (
  <div className={className}>
    <h6>{title}</h6>
    {children}
  </div>
);

export const RequestResult = {
  Block,
  Item,
};
